import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { t } from '@nextcloud/l10n'
import { computed } from 'vue'
import { useStore } from 'vuex'
import NcEmptyContent from '@nextcloud/vue/components/NcEmptyContent'
import NcModal from '@nextcloud/vue/components/NcModal'
import IconAlertOctagonOutline from 'vue-material-design-icons/AlertOctagonOutline.vue'
import { messagePleaseTryToReload } from '../../utils/talkDesktopUtils.ts'


export default /*@__PURE__*/_defineComponent({
  __name: 'CallFailedDialog',
  props: {
	token: {
		type: String,
		required: true,
	},
},
  setup(__props) {

const props = __props

const store = useStore()

const STATUS_ERRORS = {
	400: t('spreed', 'Recording consent is required'),
	403: t('spreed', 'This conversation is read-only'),
	404: t('spreed', 'Conversation not found or not joined'),
	412: t('spreed', "Lobby is still active and you're not a moderator"),
} as const
const connectionFailed = computed(() => store.getters.connectionFailed(props.token))
const connectionFailedDialogId = `connection-failed-${props.token}`
const message = computed(() => {
	if (!connectionFailed.value) {
		return ''
	}

	const statusCode: keyof typeof STATUS_ERRORS | undefined = connectionFailed.value.meta?.statuscode
	if (statusCode && STATUS_ERRORS[statusCode]) {
		return STATUS_ERRORS[statusCode]
	}
	if (connectionFailed.value?.data?.error) {
		return connectionFailed.value.data.error
	}

	return messagePleaseTryToReload
})

/**
 *
 */
function clearConnectionFailedError() {
	store.dispatch('clearConnectionFailed', props.token)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NcModal), {
    "label-id": connectionFailedDialogId,
    onClose: clearConnectionFailedError
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(NcEmptyContent), {
        name: _unref(t)('spreed', 'Connection failed'),
        description: message.value
      }, {
        icon: _withCtx(() => [
          _createVNode(IconAlertOctagonOutline)
        ]),
        _: 1
      }, 8, ["name", "description"])
    ]),
    _: 1
  }))
}
}

})